import { render } from "./tutorial.vue?vue&type=template&id=c024b0b6"
import script from "./tutorial.vue?vue&type=script&lang=js"
export * from "./tutorial.vue?vue&type=script&lang=js"

import "./tutorial.vue?vue&type=style&index=0&id=c024b0b6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__